export const setHeaders = (headersInit?: HeadersInit): HeadersInit => {
    const headers = new Headers(headersInit);

    const token = localStorage.getItem(String(import.meta.env.APP_ACCESS_TOKEN_KEY));

    token && headers.append('Authorizev3', token);

    return headers;
};
